import { render, staticRenderFns } from "./search_page.vue?vue&type=template&id=6a49c6f4"
import script from "./search_page.vue?vue&type=script&lang=js"
export * from "./search_page.vue?vue&type=script&lang=js"
import style0 from "./search_page.vue?vue&type=style&index=0&id=6a49c6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports